import React from "react";

interface RateIconProps {
    location?: "up" | "down";
}

const RateIcon = ({ location = "up" }: RateIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            style={{ transform: location === "up" ? "rotate(180deg)" : "rotate(0deg)" }}
        >
            <path
                d="M0.25551 2.20285C-0.394011 1.27496 0.269801 0 1.40243 0L10.0246 0C11.1572 0 11.821 1.27496 11.1715 2.20285L6.86044 8.36153C6.3031 9.15774 5.12393 9.15774 4.56659 8.36154L0.25551 2.20285Z"
                fill={location === "down" ? "#0047FF" : "#F00"}
            />
        </svg>
    );
};

export default RateIcon;
